import { createGroup, deleteGroup, updateGroupMembers } from "@dashboard/devices/store";
import { isAnyOf, ListenerMiddlewareInstance, UnsubscribeListener } from "@reduxjs/toolkit";

import { workspacesApi } from ".";

const workspacesActions = isAnyOf(updateGroupMembers.fulfilled, deleteGroup.fulfilled, createGroup.fulfilled);

export const initWorkspacesCacheListener = (listenerMiddleware: ListenerMiddlewareInstance): UnsubscribeListener => {
    return listenerMiddleware.startListening({
        matcher: workspacesActions,
        effect: (_action, listenerApi) => {
            listenerApi.dispatch(workspacesApi.util.invalidateTags(["Workspaces"]));
        },
    });
};
